import { audioSlice, audioWithQuoteSlice, audioWithTextSlice } from './audio';
import { contactSlice } from './contact';
import { coverCarousel } from './cover-carousel';
import { ctaLink } from './cta-link';
import { dataNovaMapSlice } from './data-nova-map';
import { downloadLink } from './download-link';
import { faqSlice } from './faq';
import { highlightedSlice } from './highlighted';
import { imageSlice, imageWithQuoteSlice, imageWithTextSlice } from './image';
import { insertSlice } from './insert';
import { internalMedia } from './internal-media';
import { keyFigure3Slice, keyFigureSlice } from './key-figure';
import { footnoteSlice, listSlice } from './list-footnote';
import { childPushsSlice, coldPushSlice } from './pushs';
import { quiz } from './quiz';
import { quoteSlice } from './quote';
import { socialMedia } from './social-media';
import {
  chapeauSlice,
  headingSlice,
  subtitleSlice,
  textSlice,
  titleSlice,
} from './text';
import { videoSlice, videoWithQuoteSlice, videoWithTextSlice } from './video';

const PRISMIC_TO_PARSER_SLICE = {
  title: titleSlice,
  subtitle: subtitleSlice,
  chapeau: chapeauSlice,
  heading: headingSlice,
  txt: textSlice,
  faq: faqSlice,
  key_figures_3: keyFigure3Slice,
  key_figure: keyFigureSlice,
  child_pushs: childPushsSlice,
  cold_push: coldPushSlice,
  cover_audio: audioSlice,
  audio_n_txt: audioWithTextSlice,
  audio_n_quote: audioWithQuoteSlice,
  list: listSlice,
  footnote: footnoteSlice,
  quote: quoteSlice,
  insert: insertSlice,
  highlighted: highlightedSlice,
  cover_image: imageSlice,
  video_n_caption: videoSlice,
  image_n_txt: imageWithTextSlice,
  video_n_txt: videoWithTextSlice,
  image_n_quote: imageWithQuoteSlice,
  video_n_quote: videoWithQuoteSlice,
  link_cta: ctaLink,
  link_download: downloadLink,
  social_media: socialMedia,
  contact: contactSlice,
  cover_carousel: coverCarousel,
  data_nova_map: dataNovaMapSlice,
  internal_media: internalMedia,
  quiz: quiz,
};

export default PRISMIC_TO_PARSER_SLICE;
